import { HttpGeneralService } from './../../shared/http-general.service';
import { Injectable } from '@angular/core';
import { CONFIG } from '../../shared/config';
import { SheetParms } from '../../shared';
import { EmrHtmlReports } from '../interface/interface';
import { HttpClient, HttpEvent, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DocManagementTrans } from '../../docu-manage-new/image-upload-new';

const medicalSheetsUrl = CONFIG.baseUrls.medicalSheets;
const saveCvDocumentUrl = CONFIG.baseUrls.SaveCvDocument;



@Injectable()
export class EmrReportsService {

  constructor(private httpGeneralService: HttpGeneralService, private httpClient: HttpClient) { }
  writtenReportsSearch(searchParms: any) {
    return this.httpGeneralService.post(searchParms, `${medicalSheetsUrl}/reports/WrittenReportsLoad`);
  }
  EmrHtmlReportsLoadAll(searchParms: any) {
    return this.httpGeneralService.post(searchParms, `${medicalSheetsUrl}/reports/EmrHtmlReportsLoadAll`);
  }

  getRadRepMainHeader(maiHeader: any) {
    return this.httpGeneralService.post(maiHeader, `${medicalSheetsUrl}/reports/GetRadRepMainHeader`);
  }

  addWrittenReports(report: SheetParms) {
    return this.httpGeneralService.post(report, `${medicalSheetsUrl}/reports/AddWrittenReports`);
  }

  
  updateWrittenReports(report: SheetParms) {
    return this.httpGeneralService.update<EmrHtmlReports>(report.serial, report, medicalSheetsUrl);
  }

  getHtmlReportForService(searchParms: EmrHtmlReports) {
    return this.httpGeneralService.post(searchParms, `${medicalSheetsUrl}/reports/HtmlReportForService`);
  }
  getPatientUltrasoundServices(report: SheetParms) {
    return this.httpGeneralService.post(report, `${medicalSheetsUrl}/reports/GetPatientUltrasoundServices`);
  }


  getReportData(sheetParms: SheetParms) {
    return this.httpGeneralService.post(sheetParms, `${medicalSheetsUrl}/reports/AppendDataToHtmlReport`);
  }


  getHtmlReportDate(serial: number) {
    return this.httpGeneralService.get(serial, `${medicalSheetsUrl}/getHtmlReportDate`);
  }
  deleteHtmlReportData(serial: number) {
    return this.httpGeneralService.delete(serial, `${medicalSheetsUrl}/deleteHtmlReportData`);
  }
  radReportUpload(file: DocManagementTrans) {
    return this.httpGeneralService.add(file, `${medicalSheetsUrl}/RadReportUpload`).toPromise();
  }
  HtmlReportDate(RegPatServiceSerial: number) {
    return this.httpGeneralService.get(RegPatServiceSerial, `${medicalSheetsUrl}/HtmlReportDate`);
  }

}
